export class BookingFilter {
    id: number;
    campus_id: number;
    course_id: number;
    suitable_from: string;
    suitable_to: string;
    lunch: any;
    code: any;
    student: string;
    week: any;
    payment_method: string;
    bus: string;
    status: string;
    hol_class_id: number;
    hol_name: string;
    school_year_id: number;
    semester_id: number;
    page: number;
    limit: number;

    student_code: string;
    student_name: string;

    constructor() {
        this.campus_id = 0;
        this.course_id = 0;
        this.lunch = 0;
        this.week = 0;
        this.bus = "";
    }
}




// WEBPACK FOOTER //
// ./src/holiday/models/BookingFilter.ts